import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Maximize, PenLine } from "lucide-react";
import { api } from "@/lib/api";
import { heure } from "@/components/tableaux/commun";

export default function MurEquipe() {
  const [d, setD] = useState(null);
  const charger = useCallback(() => api.get("/tableaux/mur").then((r) => setD(r.data)), []);
  useEffect(() => { charger(); const t = setInterval(charger, 60000); return () => clearInterval(t); }, [charger]);
  const pleinEcran = () => document.documentElement.requestFullscreen?.();
  return (
    <div className="min-h-screen p-6 md:p-12" style={{ background: "var(--bg)", color: "var(--ink)" }} data-testid="team-wall">
      <div className="flex items-center justify-between gap-3 mb-8">
        <Link to="/" className="at-btn at-btn-ghost" data-testid="team-wall-back"><ArrowLeft size={16} />Retour</Link>
        <button type="button" onClick={pleinEcran} className="at-btn at-btn-primary" data-testid="team-wall-fullscreen"><Maximize size={16} />Plein écran</button>
      </div>
      {d && (
        <div className="grid lg:grid-cols-[2fr_1fr] gap-8">
          <section>
            <p className="at-label">Signatures du jour</p>
            <p className="text-6xl md:text-8xl font-bold tracking-tight mt-2" data-testid="team-wall-total">{d.total_signes}</p>
            <div className="grid md:grid-cols-2 gap-4 mt-8">
              {d.signatures.length === 0 && <p className="text-xl at-muted">Pas encore de signature aujourd'hui. À vous de jouer !</p>}
              {d.signatures.map((s, i) => (
                <div key={s.id} className="at-card p-6 at-rise" style={{ animationDelay: `${i * 80}ms` }} data-testid={`team-wall-signature-${i}`}>
                  <p className="text-sm at-muted flex items-center gap-2"><PenLine size={16} />{heure(s.heure)} · {s.partenaire}</p>
                  <p className="text-2xl md:text-3xl font-bold mt-2">{s.client}</p>
                  <p className="text-lg mt-1">{s.operation}{s.commune ? ` · ${s.commune}` : ""}</p>
                  <p className="text-lg font-semibold mt-3" style={{ color: "var(--success)" }}>Bravo {s.agent} !</p>
                </div>
              ))}
            </div>
          </section>
          <aside className="at-card p-6 h-fit">
            <p className="at-label">Opportunités du jour</p>
            <p className="text-5xl font-bold mt-2" data-testid="team-wall-opps">{d.opportunites_jour}</p>
            <ol className="mt-6 space-y-3">
              {d.classement.map((c, i) => (
                <li key={c.agent} className="flex items-center justify-between text-xl"><span><b>{i + 1}.</b> {c.agent}</span><b>{c.opportunites}</b></li>
              ))}
            </ol>
          </aside>
        </div>
      )}
    </div>
  );
}
